import React, {
  useEffect,
  useRef,
  useState,
  Suspense,
  lazy,
  useMemo,
} from "react";
import {
  Button,
  Grid,
  Typography,
  Tooltip,
  TextField,
  InputAdornment,
} from "@mui/material";
import axios from "axios";
import Layout from "../../layout/Layout";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import * as XLSX from "xlsx/xlsx.mjs";
import { config, projectMasterAPI } from "../../config";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "react-data-table-component";
import EditLocationOutlinedIcon from "@mui/icons-material/EditLocationOutlined";
import IconButton from "@mui/material/IconButton";
import { Tooltip as ReactTooltip } from "react-tooltip";
import SearchIcon from "@mui/icons-material/Search";
import { MaterialReactTable } from "material-react-table";

function ProjectMasterReport() {
  const navigate = useNavigate();

  const [ProjectData, setProjectData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(10);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchString, setSearchString] = useState("");

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);

  let tempRefs = useRef(false);
  useEffect(() => {
    if (tempRefs.current === false) {
      fetchUsers(1);
    }
  }, []);

  const fetchUsers = async (
    page,
    rowsPerPage,
    searchString = "",
    columnName = "name",
    sortDirection = "asc"
  ) => {
    const data = JSON.stringify({
      intLimit: pageSize,
      intOffset: pageIndex * pageSize,
      txtSearchString: searchString,
      txtColumnName: columnName,
      txtSortDirection: sortDirection,
      intType: 3,
      sorting,
    });

    config.method = "POST";
    config.data = data;
    config.url = projectMasterAPI;
    axios(config)
      .then(function (response) {
        setProjectData(response.data["result"]);
        setTotalCount(response.data.totalCount);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchUsers();
  }, [pageIndex, pageSize, sorting]);

  const handlePageChange = (page) => {
    tempRefs.current = false;
    fetchUsers(page, rowsPerPage, searchString);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    if (!ProjectData.length) return; //when the table is rendered for the first time, this would trigger, and we don't need to call fetchUsers again
    tempRefs.current = false;
    fetchUsers(1, newRowsPerPage, searchString);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const handleSort = (column, sortDirection) => {
    fetchUsers(1, rowsPerPage, searchString, column.name, sortDirection);
  };

  const handleSearch = (searchString) => {
    // if (searchString.length >= 3) {
    fetchUsers(1, rowsPerPage, searchString);
    // }
  };
  const handleEditRole = (id) => {
    navigate(`/project/edit/${id}`);
  };

  const projectStatus = (status) => {
    if (status == "114") {
      return "active";
    } else {
      return "inactive";
    }
  };

  const statusStyle = {
    // display: 'flex',
    // fontSize: '20px',
    // fontWeight: 'bold',
    // gap: '10px',
    width: "6rem",
    align: "center",
  };

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
        size: 250,
      },
      {
        header: "Client Name",
        accessorKey: "client_name",
        size: 250,
      },
      {
        header: "Company Name",
        accessorKey: "company_name",
        size: 150,
      },
      {
        header: "Type of Project",
        accessorKey: "project_type",
        size: 150,
      },
      {
        header: "Type of Activity",
        accessorKey: "project_activity_type",
        size: 150,
      },
      {
        header: "Project Status",
        accessorKey: "status",
        size: 150,
        Cell: ({ cell }) => {
          const status = cell.getValue();
          const statusMap = {
            115: { label: "Active", className: "active-status" },
            137: { label: "Inactive", className: "inactive-status" },
            117: { label: "Hold", className: "hold-status" },
            118: { label: "Completed", className: "completed-status" },
          };
          const statusInfo = statusMap[status];

          return statusInfo ? (
            <Typography
              className={statusInfo.className}
              style={statusStyle}
              align="center"
            >
              {statusInfo.label}
            </Typography>
          ) : null;
        },
      },
      {
        header: "Action",
        accessorKey: "id",
        size: 80,
        enableSorting: false,

        Cell: ({ row }) => (
          <IconButton
            color="success"
            onClick={() => handleEditRole(row.original.id)}
          >
            <EditLocationOutlinedIcon />
          </IconButton>
        ),
      },
    ],
    []
  );

  let defaultValues = {
    txtName: "",
    txtLOB: "",
    txtStatus: "",
  };

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Project List
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Project</Typography>
              <Typography color="text.primary">List</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="success"
              className="button_first"
              href="/project/add"
              startIcon={<AddIcon />}
            >
              Add Project
            </LoadingButton>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          sx={{ mr: 4, mt: 2, justifyContent: `center` }}
        >
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              id="myTextField"
              label="Search"
              onKeyUp={(e) => handleSearch(e.target.value)}
              variant="outlined"
              margin="normal"
              placeholder="Search"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "40px",
                  paddingLeft: "20px", // Adjust the padding if necessary
                },
                "& .MuiInputBase-input": {
                  textAlign: "center", // Center the placeholder text
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
        {/* <Grid className="form_design">
          <Grid>
            <DataTable
              pagination
              paginationServer
              fixedHeader
              fixedHeaderScrollHeight="550px"
              columns={columns}
              data={ProjectData}
              progressPending={loading}
              paginationTotalRows={totalCount}
              paginationDefaultPage={currentPage}
              paginationRowsPerPageOptions={[1, 10, 25, 50, 100]} //you can remove it later, just to have more pages
              paginationPerPage={rowsPerPage}
              onChangePage={handlePageChange}
              onSort={handleSort}
              onChangeRowsPerPage={handleRowsPerPageChange}
            />
          </Grid>
        </Grid> */}

        <MaterialReactTable
          columns={columns}
          data={ProjectData}
          enableGlobalFilter={false}
          enableFullScreenToggle={false}
          enableColumnFilters={false}
          enableDensityToggle={false}
          className="mat-react-tbl"
          state={{
            isLoading: loading,
            pagination: { pageIndex, pageSize },
            sorting,
            columnFilters: filters,
          }}
          manualPagination
          manualSorting
          manualFiltering
          rowCount={totalCount}
          onPaginationChange={(updater) => {
            const paginationState = updater({
              pageIndex,
              pageSize,
            });
            const { pageIndex: newPageIndex, pageSize: newPageSize } =
              paginationState;
            setPageIndex(newPageIndex);
            setPageSize(newPageSize);
          }}
          onSortingChange={setSorting}
          onColumnFiltersChange={setFilters}
          muiTableBodyCellProps={{
            sx: {
              padding: "3px 8px",
              border: "1px solid #ccc",
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              "& input": {
                color: "#fff !important",
                "&::placeholder": {
                  color: "#fff !important",
                  opacity: 1,
                },
              },
              "& .MuiSelect-select": {
                color: "#fff !important", // selected text color
              },
              "& .MuiSelect-icon": {
                color: "#fff !important", // dropdown arrow color
              },
              color: "#fff",
              fontWeight: "bold",
              "& svg": {
                color: "#fff",
              },
              "& .MuiTableSortLabel-root": {
                color: "#495057",
                "&.Mui-active": {
                  color: "#fff",
                  "& .MuiTableSortLabel-icon": {
                    color: "#fff !important",
                  },
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#fff !important",
              },
            },
          }}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              borderBottom: "1px solid #ccc",
              backgroundColor: row.index % 2 === 0 ? "#ffffff" : "#e3f2fd",
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              "& input": {
                color: "#fff !important", // Change text color
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "#fff !important", // Change underline color
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "#fff !important", // Hover underline color
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#fff !important", // Focused underline color
              },
            },
          }}
        />
      </Grid>
    </Layout>
  );
}

export default ProjectMasterReport;
